import { Web } from 'brightsmith-web'

const W = new Web()
export default W
